<a
  routerLink="/your-tesla/edit/listing/images/{{ listingData?.id }}"
  class="bg-OUT-Blue rounded-full font-semibold mb-2.5 block text-center text-white w-fit py-2 px-3 text-sm -mt-9 ms-7"
>
  Upload images
</a>


<div class="relative">
    <!-- Main Image -->
    <div class="skeleton-shimmer relative rounded-xl overflow-hidden">
      <div class="h-[25vh] md:h-[35vh] 2xl:h-[45vh] w-full rounded-xl flex justify-center items-center flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-image-plus text-gray-400"><path d="M16 5h6"/><path d="M19 2v6"/><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/><circle cx="9" cy="9" r="2"/></svg>
        <p class="text-gray-600">Upload your listing image</p>
      </div>
    </div>
  
    <!-- Thumbnails -->
    <div class="sm:flex items-center gap-2 mt-2.5 overflow-x-auto hidden">
      <!-- Left Arrow -->
      <div
        class="skeleton-shimmer relative flex-none h-[90px] w-[30px] rounded"
      ></div>
  
      <!-- Thumbnails (skeleton) -->
      <div class="grid grid-cols-2 md:grid-cols-5 w-full gap-2">
        <div
          class="skeleton-shimmer relative h-[90px] rounded-lg hidden md:flex justify-center items-center w-full"
          *ngFor="let thumb of [1, 2, 3, 4, 5] "
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  class="text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-image-plus text-gray-600"><path d="M16 5h6"/><path d="M19 2v6"/><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/><circle cx="9" cy="9" r="2"/></svg>
    </div>

      </div>
  
      <!-- Right Arrow -->
      <div
        class="skeleton-shimmer relative flex-none h-[90px] w-[30px] rounded"
      ></div>
    </div>
  </div>

<div>
  <h3 class="text-2xl lg:text-3xl font-semibold">Features</h3>
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-3 xl:gap-y-0 py-3"
  >
    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M21.907 9.641a1.1 1.1 0 0 0-.088-1.05c-.27-.519-2.14-.647-2.056-.033c.034.248.1.416-.206.446a2.4 2.4 0 0 1-.137-.317l-.53-1.627a2.65 2.65 0 0 0-1.282-1.5l-.373-.2A3.9 3.9 0 0 0 15.4 4.9H8.605a3.9 3.9 0 0 0-1.837.457l-.372.2a2.65 2.65 0 0 0-1.282 1.5L4.58 8.682A2.4 2.4 0 0 1 4.444 9c-.308-.03-.241-.2-.207-.446c.084-.614-1.786-.486-2.056.033a1.1 1.1 0 0 0-.088 1.05a2.16 2.16 0 0 0 1.721.287l-1.079 1.317a2.1 2.1 0 0 0-.578 1.459l.029 5.364A1.083 1.083 0 0 0 3.3 19.1h1.644a.5.5 0 0 0 .516-.475v-.021L5.432 17.4h13.142l-.029 1.21a.5.5 0 0 0 .5.5h1.664a1.083 1.083 0 0 0 1.116-1.04l.03-5.364a2.1 2.1 0 0 0-.578-1.459l-1.091-1.324a2.16 2.16 0 0 0 1.721-.282M5.388 8.9a3.18 3.18 0 0 1 3.279-3.07h6.666a3.183 3.183 0 0 1 3.281 3.076v.45a.125.125 0 0 1-.125.124H5.512a.124.124 0 0 1-.124-.124Zm1.393 4.029a.25.25 0 0 1-.205.115h-3.06c-.136 0-.418-.062-.418-.475l.207-1.069c.071-.372.806-.351 1.133-.156L6.7 12.591a.25.25 0 0 1 .081.342zM20.7 11.5l.207 1.073c0 .413-.282.475-.418.475h-3.06a.247.247 0 0 1-.124-.457l2.266-1.247c.318-.195 1.053-.218 1.129.156"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Model</p>
        <p>{{ listingData?.vehicle?.model || 'Unknown' }}</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M18.92 2c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.21.42-1.42 1L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8zM6.5 12c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9S8 9.67 8 10.5S7.33 12 6.5 12m11 0c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M5 7l1.5-4.5h11L19 7zm2 13h4v-2l6 3h-4v2z"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Trim</p>
        <p>{{ listingData?.vehicle?.trim || 'Unknown' }}</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M20.96 16.45c.01-.15.04-.3.04-.45v.5zM11 16c0 .71.15 1.39.42 2H6v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8l2.08-6c.2-.58.76-1 1.42-1h11c.66 0 1.22.42 1.42 1L21 11v5c0-2.76-2.24-5-5-5s-5 2.24-5 5m-3-2.5c0-.83-.67-1.5-1.5-1.5S5 12.67 5 13.5S5.67 15 6.5 15S8 14.33 8 13.5M19 10l-1.5-4.5h-11L5 10zm3.87 11.19l-4.11-4.11c.41-1.04.18-2.26-.68-3.11c-.9-.91-2.25-1.09-3.34-.59l1.94 1.94l-1.35 1.36l-1.99-1.95c-.54 1.09-.29 2.44.59 3.35a2.91 2.91 0 0 0 3.12.68l4.11 4.1c.18.19.45.19.63 0l1.04-1.03c.22-.18.22-.5.04-.64"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Modifications</p>
        <p>
          {{
            listingData?.vehicle?.keyInfo?.includes('Modifications')
              ? 'Yes'
              : 'No'
          }}
        </p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 2048 2048"
        >
          <path
            fill="currentColor"
            d="M1664 512h256v1536H256V512h256V384h128v128h896V384h128zm128 128h-128v128h128zm-256 0H640v128h896zm-1024 0H384v128h128zM384 1920h1408V896H384zM256 384V256H128v1408H0V128h256V0h128v128h896V0h128v128h256v128h-256v128h-128V256H384v128zm384 1024v-128h128v128zm256 0v-128h128v128zm256 0v-128h128v128zm256 0v-128h128v128zm-768 256v-128h128v128zm256 0v-128h128v128zm256 0v-128h128v128zm-256-512v-128h128v128zm256 0v-128h128v128zm256 0v-128h128v128z"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Year</p>
        <p>{{ listingData?.vehicle?.year || 'Unknown' }}</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M12 5c-1.1 0-2 .9-2 2v1H6.5c-.66 0-1.22.42-1.42 1L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-6c-.2-.58-.76-1-1.42-1H14V7a2 2 0 0 0-2-2M6.5 9.5h11L19 14H5zm0 6.5c.83 0 1.5.67 1.5 1.5S7.33 19 6.5 19S5 18.33 5 17.5S5.67 16 6.5 16m11 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5M16.2 3.4C15 2.3 13.5 1.7 12 1.7s-3 .6-4.2 1.7L7 2.6C8.4 1.2 10.2.5 12 .5s3.6.7 5 2.1zm-.9.8l-.8.8c-.7-.7-1.6-1-2.5-1s-1.8.3-2.5 1l-.8-.8c.9-.9 2.1-1.4 3.3-1.4s2.4.5 3.3 1.4"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Autopilot</p>
        <p>
          {{ listingData?.vehicle?.features?.['autopilot'] || 'Unknown'}}
        </p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g fill="none">
            <path
              d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
            />
            <path
              fill="currentColor"
              d="M3.468 16.745c.495-.958 1.54-1.6 2.804-1.441a34 34 0 0 1 3.97.726c2.01.502 3.771 1.467 5.073 2.348l.44.306l.4.295l.358.276l.314.254l.267.226l.22.192c.843.751.27 1.978-.685 2.068l-.112.005H7.923c-1.682 0-3.08-.845-4.104-2.126c-.774-.967-.84-2.183-.35-3.129ZM19 2c.893 0 1.278.84 1.467 1.61l.06.268l.024.128c.144.797.221 1.842.252 2.916c.06 2.125-.062 4.602-.327 5.795c-.462 2.082-1.14 3.529-1.952 4.401c-.826.89-1.942 1.291-2.971.776c-.789-.394-1.26-1.331-1.518-2.13a5.73 5.73 0 0 1 .017-3.58c.21-.632.588-1.142 1.004-1.627l.363-.411c.442-.495.885-.99 1.187-1.593c.44-.88.56-1.843.597-2.81l.014-.58l.009-.56l.006-.138l.02-.28C17.347 3.107 17.716 2 19 2"
            />
          </g>
        </svg>
      </span>
      <div>
        <p class="font-semibold">Mileage</p>
        <p>{{ (listingData?.vehicle?.mileage | number) || 0 }} miles</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
            <path
              d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m4 7h4m-4 5h4m-8-5h.01M8 16h.01"
            />
          </g>
        </svg>
      </span>
      <div>
        <p class="font-semibold">Listing ID</p>
        <p>{{ listingData?.shortId || 'Unknown' }}</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M19 15h-2v-2h2m1 7v2h-4v-2h1v-2h-1v-2h3v4m-.08-15a1.5 1.5 0 0 0-1.42-1h-11a1.5 1.5 0 0 0-1.42 1L3 11v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h5a7 7 0 0 1 7-7a6.84 6.84 0 0 1 3 .68V11M6.5 15A1.5 1.5 0 1 1 8 13.5A1.5 1.5 0 0 1 6.5 15M5 10l1.5-4.5h11L19 10Z"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">VIN</p>
        <p>{{ listingData?.vehicle?.vin || 'Unknown' }}</p>
      </div>
    </div>

    <div class="flex gap-2 py-2 md:py-3">
      <span
        class="rounded-full border flex justify-center items-center px-2.5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        >
          <path
            fill="currentColor"
            d="M15 2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h2V0h2v2h6V0h2zM3 6v12h14V6zm6 5V9h2v2h2v2h-2v2H9v-2H7v-2z"
          />
        </svg>
      </span>
      <div>
        <p class="font-semibold">Listing date</p>
        <p>
          <span *ngIf="listingData?.vehicle?.year; else unknown">
            {{ listingData?.created | date }}
          </span>
          <ng-template #unknown>Unknown</ng-template>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- seller's note -->
<div>
  <h3 class="text-2xl lg:text-3xl font-semibold">Summary</h3>
  <div [innerHTML]="getFormattedDescription()"></div>
</div>
